import { render, staticRenderFns } from "./UpdateRoute.vue?vue&type=template&id=3802b700&"
import script from "./UpdateRoute.vue?vue&type=script&lang=js&"
export * from "./UpdateRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports